import ReactMarkdown from 'react-markdown';
import { cn } from '@/lib/utils';

export const chatMarkdownStyles = cn(
  'text-sm leading-relaxed flex flex-col gap-2',
  '[&_p]:m-0',
  '[&_a]:font-medium [&_a]:text-foreground [&_a]:underline [&_a]:decoration-stone-300 [&_a]:underline-offset-2 [&_a:hover]:decoration-stone-500',
  '[&_code]:rounded-md [&_code]:bg-stone-100 [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-[0.8125rem] [&_code]:text-stone-800',
  '[&_pre]:my-0 [&_pre]:overflow-x-auto [&_pre]:rounded-lg [&_pre]:bg-stone-100 [&_pre]:p-3',
  '[&_pre_code]:bg-transparent [&_pre_code]:p-0 [&_pre_code]:text-stone-700',
  '[&_ul]:my-0 [&_ul]:list-disc [&_ul]:pl-4',
  '[&_ol]:my-0 [&_ol]:list-decimal [&_ol]:pl-4',
  '[&_li]:mb-0.5',
  '[&_strong]:font-semibold',
  '[&_em]:italic',
  '[&_h2]:mb-0 [&_h2]:mt-1 [&_h2]:text-base [&_h2]:font-semibold',
  '[&_h3]:mb-0 [&_h3]:mt-0.5 [&_h3]:text-sm [&_h3]:font-semibold',
  '[&_blockquote]:my-0 [&_blockquote]:rounded-lg [&_blockquote]:bg-stone-50 [&_blockquote]:px-3 [&_blockquote]:py-2 [&_blockquote]:italic [&_blockquote]:text-stone-600',
  '[&_table]:border-collapse [&_table]:text-xs',
  '[&_thead]:bg-stone-50',
  '[&_th]:border-b [&_th]:border-stone-200 [&_th]:px-2 [&_th]:py-1.5 [&_th]:text-left [&_th]:font-medium [&_th]:text-stone-500',
  '[&_td]:border-b [&_td]:border-stone-100 [&_td]:px-2 [&_td]:py-1.5',
  '[&_tr:last-child_td]:border-b-0',
  '[&_tr:hover]:bg-stone-50',
  '[&_td]:tabular-nums',
);

const chatMarkdownComponents = {
  table: ({
    node,
    children,
    ...props
  }: React.ComponentPropsWithoutRef<'table'> & { node?: unknown }) => (
    <div className="max-w-full overflow-x-auto rounded-lg border border-stone-200">
      <table {...props}>{children}</table>
    </div>
  ),
};

interface ChatMarkdownProps {
  children: string;
  className?: string;
}

export function ChatMarkdown({ children, className }: ChatMarkdownProps) {
  return (
    <div className={cn(chatMarkdownStyles, className)}>
      <ReactMarkdown components={chatMarkdownComponents}>
        {children}
      </ReactMarkdown>
    </div>
  );
}
